<main
  (keyPress)="onKeyPress($event)"
  [attr.aria-label]="accessibilityConfig.mainContainerAriaLabel"
  [isOpen]="isOpen"
  [title]="accessibilityConfig.mainContainerTitle"
  class="main-image-container"
  ksKeyboardNavigation
>
  <div class="left-sub-container">
    <a
      (click)="onNavigationEvent('left', $event, normalAction, isFirstImage)"
      (keyup)="onNavigationEvent('left', $event, normalAction, isFirstImage)"
      [attr.aria-label]="accessibilityConfig.mainPrevImageAriaLabel"
      [tabindex]="isFirstImage ? -1 : 0"
      class="nav-left {{isFirstImage ? 'no-pointer' : ''}}"
      role="button"
    >
      <ng-container *ngIf="!isFirstImage; else emptyLeftArrow">
        @if ((design$ | async) === 'classic') {
          <fa-icon [icon]="['fas', 'chevron-left']" class="arrow-icon"></fa-icon>
        } @else {
          <app-icon
            [color]="'#007bff'"
            [iconName]="['Arrows', 'left']"
            [title]="accessibilityConfig.mainPrevImageTitle"
            aria-hidden="true"
            class="inside left-arrow-image"
          ></app-icon>
        }
      </ng-container>
      <ng-template #emptyLeftArrow>
        <div aria-hidden="true" class="inside empty-arrow-image"></div>
      </ng-template>
    </a>

    <ng-container *ngIf="configSlide?.sidePreviews?.show">
      <ng-container *ngFor="let leftPreview of getLeftPreviewImages()">
        <img
          (click)="onNavigationEvent('left', $event, clickAction)"
          (keyup)="onNavigationEvent('left', $event, keyboardAction)"
          [attr.aria-label]="leftPreview.modal.ariaLabel"
          [hidden]="loading"
          [sizeConfig]="{width: configSlide.sidePreviews?.size.width, height: configSlide.sidePreviews?.size.height}"
          [src]="leftPreview.plain?.img ? leftPreview.plain.img : leftPreview.modal.img"
          [tabindex]="0"
          [title]="leftPreview.modal.title ? leftPreview.modal.title : getDescriptionToDisplay(leftPreview)"
          alt="{{leftPreview.modal.alt ? leftPreview.modal.alt : getAltDescriptionByImage(leftPreview)}}"
          class="inside current-image-previous"
          ksSize
          role="img"
        />
      </ng-container>
    </ng-container>
  </div>

  <div
    (wheel)="onWheel($event)"
    [ngClass]="getRotateClass(currentImage)"
    class="content"
  >
    @switch (modeVisibleModalSignal()) { @case (modeVisibleModal.MAIN) { @if
    (currentImage.type === 'video') {
    <app-item-video-modal-gallery
      (contentLoaded)="onContentLoad()"
      [currentImage]="currentImage"
    />
    } @else if (currentImage.type === 'audio') {
    <app-item-audio-modal-gallery
      (contentLoaded)="onContentLoad()"
      [currentImage]="currentImage"
    />
    } @else {
    <figure
      #galleryImageContainer
      (mouseout)="onMouseOut($event)"
      [style.display]="loading ? 'none' : ''"
      class="image-container"
      id="current-figure"
    >
      <img
        #galleryImage
        (click)="onImageEvent($event, clickAction)"
        (keyup)="onImageEvent($event, keyboardAction)"
        (load)="onImageLoad($event, galleryImage)"
        (loader)="loading = $event"
        (mousemove)="onMousemove($event)"
        (swipeleft)="swipe($event.type)"
        (swiperight)="swipe($event.type)"
        [attr.aria-label]="currentImage.modal.ariaLabel"
        [src]="currentImage.modal.extUrl"
        [tabindex]="0"
        alt="{{currentImage.modal.alt ? currentImage.modal.alt : getAltDescriptionByImage()}}"
        class="inside current-image"
        id="current-image"
        role="img"
      />
      <figcaption
        *ngIf="getDescriptionToDisplay() !== ''"
        [description]="configCurrentImage?.description"
        [innerHTML]="getDescriptionToDisplay()"
        class="inside description"
        ksDescription
      ></figcaption>
    </figure>
    } } @case (modeVisibleModal.IMAGE_COMMENT) {
    <div class="compare-photo">
      <img [src]="commentPhotoUrl()" alt="" />
      <span class="label">
        <span class="label-label">Фото комментария</span>
      </span>
      <span
        (click)="onCloseCommentPhoto()"
        class="close-button compare-photo__btn"
      >
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
      </span>
    </div>
    } }

    <span class="check-image">
      <app-checkbox
        (changed)="checkboxChange($event)"
        *ngIf="!loading && isCheckable"
        [checked]="isCheck"
        isHoverAnimation="false"
      ></app-checkbox>
    </span>

    <div
      *ngIf="isOpenInfoBlock"
      [style.display]="loading ? 'none' : ''"
      class="comments"
    >
      <ks-info-block
        #infoBlock
        (longerTask)="longTask($event)"
        (onClose)="closeInfoBlock($event)"
        (resetSizeStyle)="onResetSizeStyle()"
        [commentsDataSource]="commentsDataSource"
        [image]="currentImage"
        [infoBlockContent]="infoBlockContent"
        [infoTemplate]="infoTemplate"
        [user]="user"
      ></ks-info-block>
    </div>
  </div>

  <div class="right-sub-container">
    <ng-container *ngIf="slideConfig?.sidePreviews?.show">
      <ng-container *ngFor="let rightPreview of getRightPreviewImages()">
        <img
          (click)="onNavigationEvent('right', $event, clickAction)"
          (keyup)="onNavigationEvent('right', $event, keyboardAction)"
          [attr.aria-label]="rightPreview.modal.ariaLabel"
          [hidden]="loading"
          [sizeConfig]="{width: slideConfig.sidePreviews?.size.width, height: slideConfig.sidePreviews?.size.height}"
          [src]="rightPreview.plain?.img ? rightPreview.plain.img : rightPreview.modal.img"
          [tabindex]="0"
          [title]="rightPreview.modal.title ? rightPreview.modal.title : getDescriptionToDisplay(rightPreview)"
          alt="{{rightPreview.modal.alt ? rightPreview.modal.alt : getAltDescriptionByImage(rightPreview)}}"
          class="inside current-image-next"
          ksSize
          role="img"
        />
      </ng-container>
    </ng-container>

    <ng-container *ngIf="loading && configCurrentImage?.loadingConfig?.enable">
      <ks-loading-spinner
        [accessibilityConfig]="accessibilityConfig"
        [loadingConfig]="configCurrentImage?.loadingConfig"
      ></ks-loading-spinner>
    </ng-container>

    <a
      (click)="onNavigationEvent('right', $event, normalAction, isLastImage)"
      (keyup)="onNavigationEvent('right', $event, normalAction, isLastImage)"
      [attr.aria-label]="accessibilityConfig.mainNextImageAriaLabel"
      [tabindex]="isLastImage ? -1 : 0"
      class="nav-right {{isFirstImage ? 'no-pointer' : ''}}"
      role="button"
    >
      <ng-container *ngIf="!isLastImage; else emptyRightArrow">
        @if ((design$ | async) === 'classic') {
          <fa-icon [icon]="['fas', 'chevron-right']" class="arrow-icon"></fa-icon>
        } @else {
          <app-icon
            [color]="'#007bff'"
            [iconName]="['Arrows', 'right']"
            [title]="accessibilityConfig.mainNextImageTitle"
            aria-hidden="true"
            class="inside right-arrow-image"
          ></app-icon>
        }
      </ng-container>
      <ng-template #emptyRightArrow>
        <div aria-hidden="true" class="inside empty-arrow-image"></div>
      </ng-template>
    </a>
  </div>
</main>
